import Index from '../../pages/tideng/answer/index';

const base = 'answer';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/tideng/answer.js